import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/api/auth.service';
import { environment } from '../../../environments/environment';
import { FbxTableDto } from 'src/app/entity/fbxTableDto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private authService: AuthService
  ) { }

  postFile(file: File): any {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    const requestUrl = environment.backendUrl + 'api/Fbx/UploadFbxFile';
    const authHeader = this.authService.getHttpAuthorizationHeader();
    return this.httpClient.post(requestUrl, formData, { headers: authHeader });
  }

  getFbxFilesByLicenceId(licenceId: number): any {
    const requestUrl =
      environment.backendUrl + 'api/Fbx/GetFbxFileListForLicence/' + licenceId;
    const authHeader = this.authService.getHttpAuthorizationHeader();

    return this.httpClient.get<FbxTableDto[]>(requestUrl, {
      headers: authHeader,
    });
  }

  updateFile(file: File): any {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    const requestUrl = environment.backendUrl + 'api/Fbx/UpdateFbxFile';
    const authHeader = this.authService.getHttpAuthorizationHeader();
    return this.httpClient.post(requestUrl, formData, { headers: authHeader });
  }

  downloadFile(filename: string): Observable<Blob> {
    const requestUrl = environment.backendUrl + 'api/Fbx/DownloadFbxFileForWeb/' + filename;
    const authHeader = this.authService.getHttpAuthorizationHeader();

    return this.httpClient.get(requestUrl, { headers: authHeader, responseType: 'blob' });
  }

  deleteFile(filename: string, licenceId: number): any {
    const requestUrl =
      environment.backendUrl + 'api/Fbx/DeleteFbxFile/' + filename + '/' + licenceId;
    const authHeader = this.authService.getHttpAuthorizationHeader();

    return this.httpClient.post(requestUrl, filename, { headers: authHeader });
  } 
}
